// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarLayout_wrapper__yJ9+0","layoutCard":"SidebarLayout_layoutCard__XoZYB","main":"SidebarLayout_main__jjhQy","mainRestraint":"SidebarLayout_mainRestraint__k3ez8"};